import styled from '@emotion/styled'
import { useEffect, useState } from 'react'
import { color, font } from '../../styles'

interface Props {
   timeoutAmount: number
   onTimeout: () => void
   timeoutStart: boolean
   className?: string
}

const CountDownTimer: React.FC<Props> = (props) => {
   const { onTimeout, timeoutAmount, timeoutStart, className } = props
   const seconds = timeoutAmount * 1000 // seconds to milliseconds
   const [targetDate, setTargetDate] = useState(new Date().getTime() + seconds)
   const [remainingSeconds, setRemainingSeconds] = useState(seconds / 1000)

   useEffect(() => {
      if (timeoutStart) {
         setTargetDate(new Date().getTime() + seconds)
      }
   }, [timeoutStart])

   useEffect(() => {
      if (timeoutStart) {
         const countItDown = () => {
            requestAnimationFrame(() => {
               const diff = Math.floor((targetDate - new Date().getTime()) / 1000)
               setRemainingSeconds(diff)
               if (diff > 0) {
                  countItDown()
               } else {
                  onTimeout()
               }
            })
         }
         countItDown()
      }
   }, [timeoutStart, targetDate])

   const formatTime = (time: number): string => {
      if (time <= 0) {
         return '00:00'
      }
      const minutes = Math.floor(time / 60)
      const seconds = time % 60
      return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
   }

   return (
      <Holder className={`count-down-timer ${className}`}>{formatTime(remainingSeconds)}</Holder>
   )
}

const Holder = styled.span`
   font-size: 1.5em;
   color: ${color.green};
   ${font.regular};
   text-align: center;
`
export default CountDownTimer
